export default __webpack_public_path__ + "static/media/gesundheitpflegemonosignet.72e96872.png";